import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
} from "react-bootstrap";

import { AlertInfo } from "../../components/Alert/AlertInfo.jsx";
import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import { NavLink } from "react-router-dom";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables.jsx";

import Select from 'react-select';

const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
 });
const cloud_client = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});

const ADD_TODO = gql`
  mutation updateFirewall($id: Int!, $vm_image_id: Int!, $firewallType_id: Int!, $title: String!, $protocol: String!, $portDefault: Int!, $avProfile: String!, $webfilterProfile: String!, $dnsfilterProfile: String!, $applicationList: String!, $ipsSensor: String!, $emailfilterProfile: String!, $wafProfile: String!){
    createOrUpdateFirewall(id:$id, input:{ vm_image_id:$vm_image_id, firewallType_id:$firewallType_id, title:$title, protocol:$protocol, portDefault:$portDefault, avProfile:$avProfile, webfilterProfile:$webfilterProfile, dnsfilterProfile:$dnsfilterProfile, applicationList:$applicationList, ipsSensor:$ipsSensor, emailfilterProfile:$emailfilterProfile, wafProfile:$wafProfile}){
      id
    }
  }
`;

const GET_FIREWALL = gql`
  query getFirewall($firewall_id: Int!){
    firewall(id:$firewall_id){
      id
      title
      protocol
      portDefault
      avProfile
      webfilterProfile
      dnsfilterProfile
      applicationList
      ipsSensor
      emailfilterProfile
      wafProfile
      firewallType {
        value:id
        label:title
      }
    }
  }`;

  const GET_FIREWALL_TYPES = gql`
  {
    firewallType_collection{
      firewallTypes{
        value:id
        label:title
      }
    }
  }
  `;
  

class FirewallItem extends Component {

  firewall_id;
  firewall_edit;
  firewallType_id;
  parent_id;
  back_button;

  state = {
    alertInfo: ""
  };

  constructor() {
    super();

    this.start_is_blocked = true;
    
  }



  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      alertInfo: "Salvo com sucesso!"
    });

    setTimeout(() => {
      this.setState({
        alertInfo: ""
      })
    },3000);
  }

  
  render() {

    
    this.firewall_id = (this.props.match.params.id ? this.props.match.params.id : 0);


    return (


      <Query
      client={cloud_client}
      query={GET_FIREWALL}
      variables={{firewall_id:this.firewall_id}}
      >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error) {console.log(error); return <div>Erro :(</div>}
          
          this.firewall_edit = data.firewall;
       

        return (

          <Query
          client={cloud_client}
          query={GET_FIREWALL_TYPES}
          >
          {({ loading, error, data }) => {
            if (loading) return <div>Carregando...</div>;
            if (error) {console.log(error); return <div>Erro :(</div>}
              
              var firewallTypes = data.firewallType_collection.firewallTypes;
              

            return (

      <Mutation mutation={ADD_TODO} client={cloud_client}>
      {(createOrUpdateFirewall, { data }) => (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>

            <NavLink
                to={"/Firewall/"+this.props.match.params.vm_image_id}
                className="btn btn-info btn-fill"
                activeClassName=""
              >
              VOLTAR
            </NavLink>
            <NotificationSystem ref="notificationSystem" style={style} />
            
              <Card
                name="Conta"
                content={
                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();

                    createOrUpdateFirewall({variables: { 
                      id: this.firewall_id, 
                      vm_image_id: parseInt(this.props.match.params.vm_image_id),
                      firewallType_id: parseInt(e.target.elements.firewallType_id.value),
                      title: e.target.elements.title.value,
                      protocol: e.target.elements.protocol.value,
                      portDefault: (e.target.elements.portDefault.value ? e.target.elements.portDefault.value : 0),
                      avProfile: e.target.elements.avProfile.value,
                      webfilterProfile: e.target.elements.webfilterProfile.value,
                      dnsfilterProfile: e.target.elements.dnsfilterProfile.value,
                      applicationList: e.target.elements.applicationList.value,
                      ipsSensor: e.target.elements.ipsSensor.value,
                      emailfilterProfile: e.target.elements.emailfilterProfile.value,
                      wafProfile: e.target.elements.wafProfile.value
                    } });
                  }}
                  >

                  <FormGroup>
                    <ControlLabel>Tipo</ControlLabel>
                    <div>
                      <Select
                        name="firewallType_id"
                        options={firewallTypes ? firewallTypes : []}
                        className="basic-select"
                        classNamePrefix="select"
                        isClearable={true}
                        defaultValue={this.firewall_edit && this.firewall_edit.firewallType && this.firewall_edit.firewallType  ? this.firewall_edit.firewallType : ""}
                      />
                              
                    </div>
                  </FormGroup>

                  <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          name: "title",
                          label: "Serviço Instalado",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Serviço Instalado",
                          defaultValue: (this.firewall_edit && this.firewall_edit.title ? this.firewall_edit.title : "")
                        }
                      ]}
                    />

                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          name: "protocol",
                          label: "Protocolo",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "TCP, UDP",
                          defaultValue: (this.firewall_edit && this.firewall_edit.protocol ? this.firewall_edit.protocol : "")
                        }
                      ]}
                    />

                  <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          name: "portDefault",
                          label: "Porta Fixa",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Porta Fixa",
                          defaultValue: (this.firewall_edit && this.firewall_edit.portDefault ? this.firewall_edit.portDefault : "")
                        }
                      ]}
                    />

                  <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          name: "avProfile",
                          label: "Antivirus (av-profile)",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Antivirus (av-profile)",
                          defaultValue: (this.firewall_edit && this.firewall_edit.avProfile ? this.firewall_edit.avProfile : "")
                        }
                      ]}
                    />
                    <FormInputs
                        ncols={["col-md-12"]}
                        proprieties={[
                          {
                            name: "webfilterProfile",
                            label: "Web Filter (webfilter-profile)",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "Web Filter (webfilter-profile)",
                            defaultValue: (this.firewall_edit && this.firewall_edit.webfilterProfile ? this.firewall_edit.webfilterProfile : "")
                          }
                        ]}
                      />
                      <FormInputs
                          ncols={["col-md-12"]}
                          proprieties={[
                            {
                              name: "dnsfilterProfile",
                              label: "DNS Filter (dnsfilter-profile)",
                              type: "text",
                              bsClass: "form-control",
                              placeholder: "DNS Filter (dnsfilter-profile)",
                              defaultValue: (this.firewall_edit && this.firewall_edit.dnsfilterProfile ? this.firewall_edit.dnsfilterProfile : "")
                            }
                          ]}
                        />
                        <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                name: "applicationList",
                                label: "Application Control (application-list)",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Application Control (application-list)",
                                defaultValue: (this.firewall_edit && this.firewall_edit.applicationList ? this.firewall_edit.applicationList : "")
                              }
                            ]}
                          />
                          <FormInputs
                              ncols={["col-md-12"]}
                              proprieties={[
                                {
                                  name: "ipsSensor",
                                  label: "IPS (ips-sensor)",
                                  type: "text",
                                  bsClass: "form-control",
                                  placeholder: "IPS (ips-sensor)",
                                  defaultValue: (this.firewall_edit && this.firewall_edit.ipsSensor ? this.firewall_edit.ipsSensor : "")
                                }
                              ]}
                            />
                            <FormInputs
                                ncols={["col-md-12"]}
                                proprieties={[
                                  {
                                    name: "emailfilterProfile",
                                    label: "Email Filter (emailfilter-profile)",
                                    type: "text",
                                    bsClass: "form-control",
                                    placeholder: "Email Filter (emailfilter-profile)",
                                    defaultValue: (this.firewall_edit && this.firewall_edit.emailfilterProfile ? this.firewall_edit.emailfilterProfile : "")
                                  }
                                ]}
                              />
                              <FormInputs
                                  ncols={["col-md-12"]}
                                  proprieties={[
                                    {
                                      name: "wafProfile",
                                      label: "Web Application Firewall (waf-profile)",
                                      type: "text",
                                      bsClass: "form-control",
                                      placeholder: "Web Application Firewall (waf-profile)",
                                      defaultValue: (this.firewall_edit && this.firewall_edit.wafProfile ? this.firewall_edit.wafProfile : "")
                                    }
                                  ]}
                                />



                  
                  <Row>
                    <Col md={10}>
                      <AlertInfo ref="alertSave" alertInfo={this.state.alertInfo} />
                    </Col>
                    <Col md={2}>
                      <Button bsStyle="info" pullRight fill type="submit">
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                    <div className="clearfix" />
                  </form>
                }
              />

            
              
            </Col>
            
          </Row>
        </Grid>
      </div>
      )}
      </Mutation>

         
          );
          }}
          </Query>
         
         );
         }}
         </Query>
    );
  }
}

export default FirewallItem;
